import { useEffect } from 'react';
import { getDateRange, isSameDay } from '../../utils/formatTimezone';
import { getSlotByKey, getSlotIndex, getSlotKey } from '../../time-slot-picker/slots/utils';
import { bulkSlotsSize } from '../../appointmentState';
import { useFieldActions } from '../../../../contexts/field-actions-context';
export const useSlotSelectedFromTP = _ref => {
  let {
    appointmentFieldProps,
    appointmentState,
    setAppointmentState,
    setIsReloadingSlots
  } = _ref;
  const {
    value: selectedSlot
  } = appointmentFieldProps;
  const {
    actions
  } = useFieldActions();
  useEffect(() => {
    const slotSelectedByOutSource = async () => {
      // When out source select slot from another day ( for example velo user)
      if (selectedSlot != null && selectedSlot.startDate && appointmentState != null && appointmentState.selectedDate) {
        const sameDate = isSameDay(new Date(selectedSlot.startDate), appointmentState == null ? void 0 : appointmentState.selectedDate);
        if (!sameDate) {
          setIsReloadingSlots(true);
          const selectedDate = new Date(selectedSlot.startDate);
          const {
            fromDate,
            toDate
          } = getDateRange(selectedDate, 8);
          const [availabilityDatesToUpdate, availabilitySlotsToUpdate] = await Promise.all([actions == null || actions.getAvailabilityDates == null ? void 0 : actions.getAvailabilityDates({
            serviceId: appointmentFieldProps.initialData.service.id,
            timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
            fromDate,
            toDate
          }), actions == null || actions.getAvailabilitySlots == null ? void 0 : actions.getAvailabilitySlots({
            serviceId: appointmentFieldProps.initialData.service.id,
            timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
            selectedDate
          })]);
          const key = getSlotKey(selectedSlot);
          let currentSlotBulkSize = bulkSlotsSize;
          if (availabilitySlotsToUpdate) {
            const slotIndex = getSlotIndex(key, availabilitySlotsToUpdate);
            if (slotIndex && slotIndex + 1 > currentSlotBulkSize) {
              currentSlotBulkSize = slotIndex + 1;
            }
          }
          setAppointmentState({
            ...appointmentState,
            currentSlotBulkSize,
            availabilityDates: availabilityDatesToUpdate,
            selectedDate,
            availabilitySlots: availabilitySlotsToUpdate
          });
          setIsReloadingSlots(false);
        } else {
          const {
            availabilitySlots
          } = appointmentState;
          const key = getSlotKey(selectedSlot);
          if (availabilitySlots) {
            const slot = getSlotByKey(key, availabilitySlots);
            if (!slot) {
              appointmentFieldProps == null || appointmentFieldProps.onChange(undefined);
            }
          }
        }
      }
    };
    slotSelectedByOutSource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot]);
};
//# sourceMappingURL=index.js.map